export default __webpack_public_path__ + "static/media/n_wdt_c_2.0ad6fa6c.mp3";